import React, { useEffect, useState } from "react";
import ProductForm from "./ProductForm";

const AddProduct = () => { 

  return (
     <>
     <ProductForm isEditMode={false}/>
     </>
  );
};

export default AddProduct;
